import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class WhoChecklistStorage implements IDataStorage {
    
    Index: InternalIndex = new InternalIndex('patientTheatreVisitId', 'patientTheatreVisitId', true, false);
    
    tableDefinition: InternalTable = new InternalTable('WhoChecklistStorage', 'patientTheatreVisitId', false, [
        this.Index
    ]);
    
    patientTheatreVisitId: number;

    q6Options?: string;
    q6aOptions?: string;
    q7Options?: string;
    q8Options?: string;
    q9Options?: string;
    q10Options?: string;
    q11Options?: string;
    q12Options?: string;
    q13Options?: string;
    q14Options?: string;
    q15Options?: string;
    q16Options?: string;
    q17Options?: string;
    q18Options?: string;
    q19Options?: string;
    q20Options?: string;
    q21Options?: string;
    q22Options?: string;
    q23Options?: string;
    q24Options?: string;
    q25Options?: string;
    q26Options?: string;
    q27Options?: string;
    q28Options?: string;

    lastUpdated?: Date;
    syncedWithApi?: boolean;

    static getTableDefinition(): InternalTable {
        return new WhoChecklistStorage().tableDefinition;
    }
}
